export enum modes {
	DEMO = 1,
	BETA = 2
}

const config = {
	mode: modes.DEMO,
	profilingEnabled: ["1", "true"].includes(process.env.REACT_APP_PROFILING_ENABLED?.toLowerCase() || ""),
	PASSWORD_MIN_LENGTH: 6,
	PLACES_AUTOCOMPLETE_RADIUS_MILES: process.env.REACT_APP_PLACES_AUTOCOMPLETE_RADIUS_MILES
		? parseFloat(process.env.REACT_APP_PLACES_AUTOCOMPLETE_RADIUS_MILES)
		: 10,
	googleAnalyticsKey: process.env.REACT_APP_GOOGLE_ANALYTICS_KEY,
	googleTagManagerKey: process.env.REACT_APP_GOOGLE_TAG_MGR_ID,
	TOKEN_STORAGE_KEY: "at",
	FACEBOOK_APP_ID: process.env.REACT_APP_FB_APP_ID || "undefined",
	GOOGLE_APP_ID: process.env.REACT_APP_GOOGLE_APP_ID,
	STRIPE_ID: process.env.REACT_APP_STRIPE_API_KEY,

	apiUrl: process.env.REACT_APP_API_URI!,
	wsApiUrl: process.env.REACT_APP_GQL_WS_URI!,
	termsUrl: process.env.REACT_APP_TERMS_URL!,
	privacyPolicyUrl: process.env.REACT_APP_PRIVACY_POLICY_URL!,
	environment: !process.env.REACT_APP_ENV
		? "DEV"
		: process.env.REACT_APP_ENV === "PROD"
		? null
		: process.env.REACT_APP_ENV,

	readyTimeMaxDisplayMinutes: Number(process.env.REACT_APP_READY_TIME_MAX_DISPLAY_MINUTES || 90)
};

export default config;
